<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '500px' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="close()"
  styleClass="mentor-deadline-modern-dialog"
  [closable]="true"
  (onShow)="onShow()">
  
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-2">
      <span class="font-bold text-xl">Set Deadline</span>
    </div>
  </ng-template>

  <div class="flex flex-column gap-4 py-2">
  
    
    <!-- Student Program Details (Read-only) -->
    <div class="flex flex-column gap-3 p-3 border-1 border-round-xl bg-gray-50" style="border-color: #E2E8F0;">
      <div class="flex align-items-center justify-content-between">
        <span class="text-sm font-semibold text-gray-500 uppercase tracking-wider">Student Program Selections</span>
        <i class="pi pi-lock text-gray-400"></i>
      </div>
      
      <div class="grid m-0">
        <div class="col-6 p-1">
          <label class="text-xs font-bold text-gray-400 block mb-1">COURSE LEVEL</label>
          <div class="text-sm font-medium text-gray-700">{{ getCourseLevelLabel(institute.courseLevel) || 'N/A' }}</div>
        </div>
        <div class="col-6 p-1">
          <label class="text-xs font-bold text-gray-400 block mb-1">INTAKE YEAR</label>
          <div class="text-sm font-medium text-gray-700">{{ institute.inTakeYear || 'N/A' }}</div>
        </div>
        <div class="col-12 p-1 mt-2">
          <label class="text-xs font-bold text-gray-400 block mb-1">COURSE</label>
          <div class="text-sm font-medium text-gray-700">{{ institute.courseName || 'N/A' }}</div>
        </div>
      </div>
    </div>

    <!-- Deadline Selection (Styled like image) -->
    <div class="flex flex-column gap-2 px-1">
      <label class="font-bold text-base text-gray-800">Select Deadline Date</label>
      <div class="flex align-items-stretch w-full">
        <div class="flex-1 relative">
          <p-calendar
            [(ngModel)]="selectedDate"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [readonlyInput]="true"
            placeholder="Pick a date..."
            dateFormat="mm/dd/yy"
            appendTo="body"
            [style]="{'width':'100%'}"
            [inputStyle]="{'width':'100%', 'height': '48px', 'border-top-right-radius': '0', 'border-bottom-right-radius': '0', 'padding-left': '1rem'}"
            styleClass="custom-calendar-input">
          </p-calendar>
        </div>
        <div class="flex align-items-center justify-content-center bg-indigo-900 px-3 border-round-right-lg cursor-pointer"
             style="background-color: #000086; border-top-right-radius: 8px; border-bottom-right-radius: 8px;">
          <i class="pi pi-calendar text-white text-xl"></i>
        </div>
      </div>
      <small class="text-gray-400" *ngIf="maxDate">
        Must be on or before official deadline ({{ maxDate | date: 'dd MMM yyyy' }})
      </small>
    </div>

   
  </div>

  <ng-template pTemplate="footer">
    <div class="flex align-items-center justify-content-center gap-4 w-full pt-2">
      <button pButton label="Cancel" (click)="close()" 
              class="p-button-text p-button-secondary font-bold text-base" 
              style="color: #64748B; height: 48px; padding: 0 32px;"></button>
      <button pButton label="Save Deadline" (click)="save()" 
              [loading]="isSaving" icon="pi pi-check"
              class="font-bold text-base" 
              style="background-color: #C7C6F1; border-color: #C7C6F1; color: #5B4BD9; height: 48px; padding: 0 32px; border-radius: 12px;"
              [disabled]="!selectedDate"></button>
    </div>
  </ng-template>
</p-dialog>
